import React, { Component } from 'react'
import "./Button.css"

class Button extends Component {

  onClick = (e) => {
    if (!this.props.loading && this.props.onClick) this.props.onClick(e);
  }

  renderLoader() {
    return (
      <div className="ball-loader">
        {[1,2,3].map(i => <div key={i} className="ball-loader-ball" />)}
      </div>
    )
  }

  render() {
    return <button className={(this.props.loading ? 'disable-cursor' : '') + (this.props.className ? ` ${this.props.className}` : "")} onClick={this.onClick} {...this.props}>
      {this.props.loading ? this.renderLoader() : ''}
      <div className={this.props.loading ? 'hide-button-content' : ''}>
        {this.props.children}
      </div>
    </button>
  }
}

export default Button;
